
// Force external links to open in new tab / window
(function ($) {
  $(function () {
    var siteName = window.location.host.replace("www.", "");
    $(
      'a[href^="htt"]:not([target]):not([href*="www.' +
        siteName +
        '"]):not([href*="//' +
        siteName +
        '"]):not([class*="fancybox"])'
    ).attr("target", "_blank");
  });
})(jQuery);

(function ($) {
  var wowInstance = null;
  function initWOW() {
    if (wowInstance) return;
    wowInstance = new WOW({
      offset: 150,
      callback: function (box) {
        $(box).addClass("animate-complete");
      },
    });
    wowInstance.init();
  }
  function destroyWOW() {
    if (wowInstance && wowInstance.stop) {
      wowInstance.stop();
      wowInstance = null;
    }
  }
  if (window.innerWidth > 1023) {
    initWOW();
  }
  var lastIsDesktop = window.innerWidth > 1023;
  window.addEventListener("resize", function () {
    var isDesktop = window.innerWidth > 1023;
    if (isDesktop && !lastIsDesktop) {
      // Switched to desktop
      initWOW();
      if (wowInstance && wowInstance.sync) wowInstance.sync();
    } else if (!isDesktop && lastIsDesktop) {
      // Switched to mobile/tablet
      destroyWOW();
    }
    lastIsDesktop = isDesktop;
  });
})(jQuery);

(function () {
  function isSafariBrowser() {
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("safari") > -1 && ua.indexOf("chrome") === -1 && ua.indexOf("android") === -1;
  }

  if (!isSafariBrowser()) {
    return;
  }

  function markVisible(el) {
    if (!el || el.classList.contains("animated") || el.classList.contains("animate-complete")) {
      return;
    }
    el.style.visibility = "visible";
    el.classList.add("animated");
    el.classList.add("animate-complete");
  }

  function setupSection(section) {
    var targets = section.querySelectorAll(".wow");
    if (!targets.length) {
      return;
    }

    if (!("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(targets, markVisible);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            markVisible(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    Array.prototype.forEach.call(targets, function (el) {
      observer.observe(el);

      // Safety net for Safari timing glitches when WOW misses an element.
      setTimeout(function () {
        var rect = el.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top < vh * 0.9 && rect.bottom > 0) {
          markVisible(el);
          observer.unobserve(el);
        }
      }, 1200);
    });
  }

  function initSafariWowFallback() {
    var sections = document.querySelectorAll(".two-col-content-with-icon");
    Array.prototype.forEach.call(sections, setupSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSafariWowFallback);
  } else {
    initSafariWowFallback();
  }

  window.addEventListener("pageshow", initSafariWowFallback);
})();
